import React from 'react';
import { Crown, X } from 'lucide-react';
import { Button } from './ui';

/**
 * What a non-Enterprise account sees in place of the team form.
 *
 * The page itself stays open to everyone: the five agents, the deal desk and
 * the sandbox are all there to look at. Creating a team — the thing that
 * actually scouts, writes and sends — is Enterprise, and the server refuses it
 * either way (mars-backend/services/agentTeam/plan.js). `gate` is meta.plan.
 *
 * Only the account owner may open the pricing page, so a sub-user is asked to
 * speak to them instead of being sent somewhere they are refused.
 */

export const teamCreationLocked = (meta) => meta?.plan ? meta.plan.can_create_team === false : false;

const UpgradeCard = ({ gate, onUpgrade, onClose }) => (
  <div className="rounded-xl border border-amber-200 bg-amber-50 p-5 dark:border-amber-900 dark:bg-amber-950/30">
    <div className="flex items-start gap-4">
      <div className="flex h-11 w-11 flex-none items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/60">
        <Crown className="h-5 w-5 text-amber-600 dark:text-amber-300" />
      </div>
      <div className="flex-1">
        <h3 className="text-base font-semibold text-amber-900 dark:text-amber-100">
          Agent teams are part of the Enterprise plan
        </h3>
        <p className="mt-1 text-sm text-amber-800 dark:text-amber-200">
          Look around as much as you like: this is where a team would scout untapped affiliates for one of your
          brands, vet them, email them and negotiate inside the deal you saved.
          {gate?.plan ? ` Your plan is ${gate.plan}.` : ''} To put a team to work, you need Enterprise.
        </p>
        <div className="mt-4 flex flex-wrap items-center gap-2">
          {gate?.is_owner === false ? (
            <span className="text-sm font-medium text-amber-900 dark:text-amber-100">
              Ask the account owner to upgrade to Enterprise.
            </span>
          ) : (
            <Button variant="primary" icon={Crown} onClick={onUpgrade}>View pricing plans</Button>
          )}
          {onClose && <Button icon={X} onClick={onClose}>Maybe later</Button>}
        </div>
      </div>
    </div>
  </div>
);

export default UpgradeCard;
